export const ThemeIndex = {
  v1: undefined, // 经典
  v2: 2, // 娱乐
  v3: 3, // 国际
  v4: 4 // 娱乐国际
};
